import { Button } from '@/components/ui/button'
import ChatSendStop from '@/assets/images/chat/chat_send_stop.svg?react'
import SendIcon from '@/assets/images/icon/send.svg?react'

export interface ISendBtnProps {
  loading?: boolean
  curValue: string
  onSend: () => void
  onStop: () => void
}
export const SendBtn = ({
  curValue,
  loading,
  onSend,
  onStop,
}: ISendBtnProps) => {
  return (
    <>
      {loading ? (
        <Button
          size="icon"
          onClick={onStop}
          className="ml-[10px] size-7 rounded-full text-content-first bg-transparent hover:bg-transparent"
        >
          <ChatSendStop />
        </Button>
      ) : (
        <Button
          size="icon"
          variant="primarygradient"
          disabled={!curValue}
          className="ml-[10px] size-7 rounded-full disabled:opacity-1 disabled:from-content-forbidden disabled:to-content-forbidden"
          onClick={onSend}
        >
          <SendIcon />
        </Button>
      )}
    </>
  )
}

export default SendBtn
